<template>
  <div id="companyProfile">
    <!-- <div class="row top_dv"> -->
          <nav class="navbar navbar-default navbar-fixed-top">
      <!-- We use the fluid option here to avoid overriding the fixed width of a normal container within the narrow content columns. -->
          <div class="container-fluid">
            <div class="navbar-header">
              <img :src="HomeLogo" class="nav_Image">
            </div>

            <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-6">
              <ul class="nav navbar-nav nav_ul" >
                <li class="active" id="active_li" v-for="(target,id) in navList" :key="id" @click="choseprofrom(id)"  >
                  <router-link :class="{'secectBackground':flag==id}" :to="target.ur">{{target.name}}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      <!-- </div> -->
  </div>
</template>

<script>

export default {
  data(){
    return{
      navList:[
              {name:"首页",id:0,ur:'/'},
              {name:"公司简介",id:1,ur:'/CompanyProfile'},
              {name:"公司产品",id:2,ur:'/CompanyProducts',},
              {name:"公司动态",id:3,ur:'/Dynamic'},
              // {name:"合作伙伴",id:4,ur:'/CooperativePartner'},
              {name:"联系我们",id:4,ur:'/ContactUs'},
              // {id:6,ur:'/Detailstest'},
      ],
      // flag: -1,
    }
  },
   created(){
    //  console.log(this.$route)
     if(document.body.clientWidth > 750){
        this.HomeLogo = '../../static/image/webLogo.png'
     }else  {
        this.HomeLogo = '../../static/image/appLogo.png'
        this.navList.splice(4,1)
     }
     for(var i = 0 ;i<this.navList.length;i++){
      if(this.$route.path == this.navList[i].ur){
        this.flag = this.navList[i].id
        // console.log(this.navList[i].id)
      }
     }
  },
  methods:{
      choseprofrom:function (id) {
        this.flag = id;
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/css/Overall.css';

</style>



// WEBPACK FOOTER //
// src/components/publicComponent/Navigation.vue